<section class="breadcrumb-section-main inner-2 breadcrumb-section-sm">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="breadcrumb-contain ">
                    <div>
                        <h2 class="breadcrumb-txt">Profil</h2>
                    </div>
                    <div>
                        <ul>
                            <li><a href="#">Profil</a></li>
                            <li><a href="#"><i class="fa fa-angle-double-right"></i>Übersicht</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section-b-space">
    <div class="collection-wrapper">
        <div class="container">
            <div class="row">
                <div class="collection-content col">
                    <div class="page-main-content">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="top-banner-wrapper">
                                        <div class="top-banner-content small-section">
                                            <h4>Willkommen zurück {{ user_name }}</h4>
                                            <h5>Hier findest du alle deine Bestellten Tabellen</h5>
                                            <p>
                                                Hier kannst du alle deine bestellten Tabellen im Excel- und CSV-Format herunterladen. Außerdem erhältst du einen Überblick über den aktuellen Status deiner Bestellungen. <br>
                                                Bei Fragen stehen wir dir jederzeit zur Verfügung!
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="py-5 bg-light">
    <div class="container">
        <div class="row justify-content-center">
            <div *ngFor="let item of searchResults" class="col-12 col-md-10 mb-4">
                <div class="card shadow-lg rounded-4 border-0">
                    <div class="card-header d-flex justify-content-between align-items-center bg-white border-0 rounded-top-4">
                        <div>
                            <h5 class="mb-0 fw-bold text-primary text-capitalize">{{ item.orderTable }}</h5>
                            <small class="text-secondary">{{ item.orderTimestamp | date:'medium' }}</small>
                        </div>
                        <div>
                          <span class="badge" [ngClass]="item.payed ? 'bg-success' : 'bg-warning text-dark'">
                            {{ item.payed ? 'Bezahlt' : 'Ausstehend' }}
                          </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row gy-2">
                            <div class="col-12 col-md-6">
                                <strong>Bestell-ID:</strong>
                                <div class="text-break">{{ item.orderId }}</div>
                            </div>
                            <div class="col-12 col-md-6">
                                <strong>Zahlungsmethode:</strong>
                                <div>{{ item.paymentMethod }}</div>
                            </div>
                            <div class="col-12 col-md-6">
                                <strong>Regionen:</strong>
                                <div>
                                  <span *ngFor="let region of item.orderStates.split(','); let i = index">
                                    {{ region }}<span *ngIf="i < item.orderStates.split(',').length - 1">, </span>
                                  </span>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <strong>Anzahl Einträge:</strong>
                                <div>{{ item.orderQuantity | number }}</div>
                            </div>
                            <div class="col-12 col-md-6">
                                <strong>Preis:</strong>
                                <div>{{ item.orderPrice | number:'1.2-2' }} €</div>
                            </div>
                            <div class="col-12 col-md-6">
                                <strong>Spalten:</strong>
                                <div>{{ item.orderInfos }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer bg-white border-0 d-flex justify-content-end gap-2 rounded-bottom-4">
                        <button class="btn btn-primary btn-sm" (click)="download_csv(item.orderTable)">CSV herunterladen</button>
                        <button class="btn btn-success btn-sm" (click)="download_excel(item.orderTable)">Excel herunterladen</button>
                    </div>
                </div>
            </div>
            <div class="col-12 d-flex justify-content-center mt-3">
                <button class="btn btn-outline-danger" (click)="logout()">
                    Logout
                </button>
            </div>
        </div>
    </div>
</section>